export default __webpack_public_path__ + "static/media/android_step1.34facaaa.jpg";